module.exports = __webpack_public_path__ + "static/media/cert5.7f49ac0b.png";